import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Layouts from "./components/Layouts/plugin";

import router from './router.js';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
Vue.use(BootstrapVue);
Vue.use(Layouts);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#App');